import React from 'react';
import InventoryListFunctional from './components/inventory-list-functional';
import './inventory.scss';

const InventoryList = () => {
	return <InventoryListFunctional />;
};

export default InventoryList;
